import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { loadClaim, loadReferrals, actions } from '../claimsSlice';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Container,
    Button,
    TextField,
    Typography,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import SendIcon from '@mui/icons-material/Send';

import { ClaimReferrals } from './ClaimReferrals';
import { ClaimInfo } from '../ClaimInfo';
import {useForm} from "react-hook-form";

const  { clearClaim } = actions;

const useStyles = makeStyles(theme => ({
    header: {
        backgroundColor: theme.palette.primary.main,
        color: theme.colors.white
    },
    text: {
        color: theme.typography.color
    },
    whiteText: {
        color: theme.colors.white
    },
    bold: {
        fontWeight: theme.typography.fontWeightBold
    },
    cardTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.colors.white,
    },
    dateFilter: {
        width: '150px'
    },
    formMargin: {
        marginTop: '15px'
    }
}));



function CustomerClaimDetail() {

    const { claimId } = useParams();
    const dispatch = useDispatch();
    const classes = useStyles();
    const theme = useTheme();
    const belowSm = useMediaQuery(theme.breakpoints.down('md'));
    // const claimCollapsible = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    // Logging to DEBUG. as cant run local. TODO delete after debug
    /*
    const log = (...args) => console.log('[CustomerClaimDetail]', ...args);
    useEffect(() => {
        log('mounted');
        return () => log('unmounted');
    }, []);

    useEffect(() => {
        log('route params change', { claimId, typeof: typeof claimId });
    }, [claimId]);

// Log key state slice changes
    useEffect(() => {
        log('claimDetail slice change', {
            claimLoading,
            referralsLoading,
            referralFilterDate,
            claim,
            details,
            patientPhones,
            referralsLength: referrals?.length ?? 0,
        });
    }, [
        claimLoading,
        referralsLoading,
        referralFilterDate,
        claim,
        details,
        patientPhones,
        referrals,
    ]);

     */


    const { 
        claimLoading, claim, referrals, details, patientPhones, referralsLoading, referralFilterDate
    } = useSelector(state => state.claims.claimDetail);
    
    const { register, handleSubmit, reset, setValue } = useForm();

    useEffect(() => {
        dispatch(loadClaim({ claimId, userType: 'Customer' }));
    }, [dispatch, claimId]);

    useEffect(() => {
        setValue('startDate', referralFilterDate);
    }, [referralFilterDate, setValue]);

    useEffect(() => {
        return () => {
            dispatch(clearClaim())
        }
    }, [dispatch]);

    // GESX Router 6, no listen , thus replace with this and run on unmount
    //TODO del comment:: navigate.listen(_ => dispatch(clearClaim()));
    const submitReferral = () => {
        navigate('/referral/create', { state: { claim } });
        };


    const onSubmit = values => {
        const { startDate, endDate } = values;
        dispatch(loadReferrals({ claimId, fromDate: startDate, toDate: endDate }));
    }

    const handleResetDateFilter = () => {
        reset();
    }

    return (
        <Container maxWidth="xl">
            <Grid container spacing={2}>
                <Grid item md={3} xs={12}>
                    <ClaimInfo loading={claimLoading} claim={claim} patientPhones={patientPhones}/>
                </Grid>
                <Grid item md={9} xs={12}>
                    <Card variant="outlined">
                        <CardHeader title="Referrals" className={classes.header}>
                        </CardHeader>
                        <CardContent>
                            <Grid container justifyContent={"space-between"}>
                                <Button onClick={submitReferral} className={classes.button} startIcon={<SendIcon/>} disabled={claimLoading} variant="contained" color="secondary">
                                    Submit New Referral
                                </Button>
                                <form onSubmit={handleSubmit(onSubmit)} className={belowSm ? classes.formMargin : null}>
                                    <Grid container item spacing={2}>
                                        <Grid item sm={4} xs={6}>
                                            <TextField
                                                name="startDate"
                                                label="Last Activity"
                                                type="date"
                                                InputLabelProps={{shrink: true}}
                                                {...register("startDate",{})}
                                                className={classes.dateFilter}
                                            />
                                        </Grid>
                                        <Grid item sm={4} xs={6}>
                                            <TextField
                                                name="endDate"
                                                label="To Date"
                                                type="date"
                                                InputLabelProps={{shrink:true}}
                                                {...register("endDate",{})}
                                                className={classes.dateFilter}
                                            />
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Button type="submit" variant="contained" color="secondary" disabled={referralsLoading}>
                                                Filter
                                            </Button>
                                        </Grid>
                                        <Grid item sm={2}>
                                            <Button variant="contained" color="inherit" onClick={handleResetDateFilter}>
                                                Reset
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>

                            <br/>
                            <ClaimReferrals referrals={referrals} details={details} />
                            <br/>
                            {referrals && referrals.length === 0 && !referralsLoading && <Typography align={'center'}>
                                No referrals found
                            </Typography>}
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export { CustomerClaimDetail };